<script>
    let parser;
    let xmlDoc;
    let items; // To parse elements in xml
    let xmlDoc1;
    let items1; // To parse elements in html (image and escription detail required)
    const dataArray = [];
    fetch('https://api.allorigins.win/get?url=https://blog.opus.ai/feed')
        .then((response) => response.json())
        .then((r) => {
            parser = new DOMParser();
            xmlDoc = parser.parseFromString(r.contents, 'text/xml');
            xmlDoc1 = parser.parseFromString(r.contents, 'text/html');
            items = xmlDoc.getElementsByTagName('item');
            items1 = xmlDoc1.getElementsByTagName('item');
            for (let i = 0; i < items.length; i++) {
                const dataObj = {};
                dataObj.title = items[i].getElementsByTagName('title')[0].childNodes[0].nodeValue;
                dataObj.creator = items[i].getElementsByTagName('dc:creator')[0].childNodes[0].nodeValue;
                dataObj.img =items1[i].getElementsByTagName('content:encoded')[0].
                    getElementsByTagName('img')[0].attributes[1].nodeValue;
                dataObj.description =items1[i].getElementsByTagName('content:encoded')[0].innerText;
                dataObj.link = items[i].querySelector('link').innerHTML;
                dataArray[i] = dataObj;
            }
        });
</script>

<section>
    <p class="read">READ OUR BLOG</p>
    <div class="twitter-blog-wrapper">
        {#each dataArray as data, id}
            {#if id >= 3 && id <= 5}
                <div class="blog">
                    <div class="title">
                        <a href={data.link}>
                            {data.title}
                        </a>
                    </div>
                    <div class="creator">
                        {data.creator}
                    </div>
                    <div class="detail">
                        <div class="description">
                            {data.description}
                        </div>
                        <div class="img-wrapper">
                            <img height="100%" src={data.img} alt="" />
                        </div>
                    </div>
                </div>
            {/if}
        {/each}
    </div>
    <div class="explore-btn-wrapper" style="margin-top: 2vw;">
        <a href="https://blog.opus.ai">Explore Blog</a>
    </div>
</section>

<style>
    section {
        margin-top: 8.148vh;
    }
    .read {
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 900;
        font-size: 1.042vw;
        line-height: 1.302vw;
        letter-spacing: 0.02em;
        color: #ffffff;
        padding-left: 4.063vw;
        margin-bottom: 3.056vh;
    }
    .twitter-blog-wrapper {
        width: 25vw;
        color: #000000;
        margin-left: 2.083vw;
        height: 62.685vh;
        overflow-y: scroll;
    }
    .twitter-blog-wrapper::-webkit-scrollbar {
        display: none;
    }
    .blog {
        width: 100%;
        height: 10.573vw;
        background: #ffffff;
        border-radius: 2.083vw;
        background-color: white;
        font-family: "Roboto";
        font-style: normal;
        padding: 1.563vw 1.25vw 1.563vw 1.979vw;
        box-sizing: border-box;
        margin-bottom: 3.148vh;
    }
    .title {
        font-weight: 700;
        font-size: 0.938vw;
        line-height: 1.094vw;
    }
    .creator {
        margin-top: 0.463vh;
        font-family: "Helvetica";
        font-style: normal;
        font-weight: 400;
        font-size: 0.521vw;
        line-height: 0.573vw;
        color: #8698a9;
    }
    .detail {
        height: 5vw;
        overflow: hidden;
        display: flex;
        justify-content: space-between;
        align-content: center;
        margin-top: 1.481vh;
    }
    .description {
        width: 15.208vw;
        height: 4.688vw;
        font-family: "Helvetica";
        font-style: normal;
        font-weight: 400;
        font-size: 0.729vw;
        line-height: 0.938vw;
        color: #000000;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
    .img-wrapper {
        width: 5.104vw;
        height: 5vw;
        border-radius: 1.042vw;
        overflow: hidden;
    }
    .explore-btn-wrapper a {
        margin: 5vh 0vw 0vh 9.635vw;
        border: 0.052vw solid #ffffff;
        padding: .8vw 1.8vw;
        font-family: "Orbitron";
        font-style: normal;
        font-weight: 400;
        font-size: 0.729vw;
        line-height: 0.938vw;
        letter-spacing: 0.02em;
        color: #ffffff;
        background-color: transparent;
    }
</style>
